<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="背景图片">
				<el-upload
					class="avatar-uploader"
					:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
					:auto-upload="false"
					:show-file-list="false"
					:on-change="
						(file, fileList) => {
							handleImport(file, fileList, 'backgroundImage');
						}
					"
					accept="image/gif,image/jpeg,image/jpg,image/png"
					drag
				>
					<img v-if="list.backgroundImage" :src="list.backgroundImage" class="avatar" />
					<i v-else class="el-icon-upload"></i>
				</el-upload>
			</el-form-item>
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="内边距">
				<el-input-number v-model="list.paddingTop" placeholder="单位像素（px）" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="左边距">
				<el-input-number v-model="list.paddingLeft" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="右边距">
				<el-input-number v-model="list.paddingRight" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-plus" class="add-image" @click="addList"> 添加列 </el-button>
			</el-form-item>
		</el-form>

		<el-form label-width="70px">
			<el-form-item class="listData" :label="'第' + (index + 1) + '项'" v-for="(item, index) in list.data" :key="index">
				<el-form-item>
					<el-upload
						class="avatar-uploader"
						:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
						:auto-upload="false"
						:show-file-list="false"
						:on-change="
							(file, fileList) => {
								handleImport(file, fileList, 'Simg', index);
							}
						"
						accept="image/gif,image/jpeg,image/jpg,image/png"
						drag
					>
						<img v-if="list.data[index].Simg" :src="list.data[index].Simg" class="avatar" />
						<i v-else>药品图</i>
					</el-upload>
				</el-form-item>
				<el-upload
					class="avatar-uploader input_two"
					:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
					:auto-upload="false"
					:show-file-list="false"
					:on-change="
						(file, fileList) => {
							handleImport(file, fileList, 'Bimg', index);
						}
					"
					accept="image/gif,image/jpeg,image/jpg,image/png"
					drag
				>
					<img v-if="list.data[index].Bimg" :src="list.data[index].Bimg" class="avatar" />
					<i v-else>药品大图</i>
				</el-upload>
				<el-button type="danger" icon="el-icon-delete" circle @click="deleteListData(index)"></el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	name: 'combinedMedica',
	props: ['data'],
	data() {
		return {
			list: {},
		};
	},
	mounted() {
		this.list = this.data;
	},
	methods: {
		addList() {
			this.list.data.push({ Simg: '', Bimg: '' });
		},
		deleteListData(val) {
			delete this.list.data.splice(val, 1);
		},
		handleImport(file, fileList, name, index) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
			const params = new FormData();
			params.append('file', file.raw);
			var loading = this.$loading({
				lock: true,
				text: '图片上传中',
			});
			var url = 'https://app.kcguoyi.com/api/service/upload/uploadImage';
			axios
				.post(url, params, {
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				.then((res) => {
					if (index != undefined) {
						this.list.data[index][name] = res.data.body[0].url;
					} else {
						this.list[name] = res.data.body[0].url;
					}
				})
				.finally(() => {
					this.$nextTick(() => {
						this.$forceUpdate();
					});
					loading.close();
				});
		},
	},
};
</script>

<style scoped>
.info-content {
	padding: 20px;
	overflow-y: auto;
}

.listData .el-input-number {
	width: 160px;
}
.listData .el-input {
	width: 160px;
}
.listData .el-button {
	/* float: right;
	margin-top: 10px; */
	position: absolute;
	right: 0;
	top: 35%;
}
.input_two {
	margin-top: 10px;
}

div /deep/ .normal-uploader .el-upload-dragger {
	width: 180px;
	height: 100px;
}
div /deep/ .normal-uploader .el-upload-dragger .el-icon-upload {
	margin-top: 20px;
}

div /deep/ .avatar-uploader .el-upload-dragger {
	width: 120px;
	height: 80px;
}
div /deep/ .avatar-uploader .el-upload-dragger .el-icon-upload {
	margin-top: 15px;
}

.normal-uploader .avatar {
	width: 180px;
	height: 100px;
	display: block;
}

.avatar-uploader .avatar {
	width: 120px;
	height: 80px;
	display: block;
}
</style>